import React, { useState } from "react";

const Tab = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="w-full">
      <div className="flex flex-wrap border-b border-gray-200 mb-6 sm:mb-8 overflow-x-auto">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={`px-4 sm:px-6 py-2.5 sm:py-3 font-semibold transition-all duration-300 border-b-2 whitespace-nowrap text-sm sm:text-base ${
              activeTab === index
                ? "border-primary-600 text-primary-600"
                : "border-transparent text-gray-600 hover:text-primary-600"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tab-content">{tabs[activeTab].content}</div>
    </div>
  );
};

export default Tab;
